export default "https://cdn-static.gokick.com/assets/76516c8a60965c2814adf9f2d5cc0638cda6ee5d/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";